export const CIVIC_LOCATION = 'CIVIC';
export const GEODETIC_LOCATION = 'GEODETIC';
export const BOTH = 'BOTH';
export const AREA_OF_INTEREST = 'AREA_OF_INTEREST';
